import { ApiResponse } from "../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";


const SERVICE_URL = ServiceEndPoint.account_service; 

export async function submitClientForm(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}clients`, payload);
  return response.data;
}

export async function fetchList(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}clients/query`, payload);
  return response.data;
}

export async function changeStatus(url:string,payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.put(`${SERVICE_URL}${url}`, payload);
  return response.data;
}
export async function deleteClient(id:number): Promise<ApiResponse<any>>{
  const response = await axiosService.delete(`${SERVICE_URL}clients/${id}`);
  return response.data;
}

export async function getClientDetails(id?:string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}clients/${id}`);
    return response.data;
}

export async function updateClient(payload:any,id?:number): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}clients/${id}`,payload);
  return response.data;
}